export const THAI_NATIONALITY_ID = 169
export const OTHER_NATIONALITY_ID = 0
